/**
 * Campaign Stepper Component
 * 
 * Displays the step indicator for campaign creation process:
 * - Step 1: Basic Information
 * - Step 2: Link Promos & Funding (optional)
 * - Step 3: Summary
 */

import React from 'react';
import { CampaignStepConfig } from '../../../../../api/promos/types';
import '../../../../../Common/Stepper/Stepper.css'; // We'll create this CSS file

interface CampaignStepperProps {
  steps: CampaignStepConfig[];
  currentStep: number;
  onStepClick: (stepIndex: number) => void;
}

const CampaignStepper: React.FC<CampaignStepperProps> = ({
  steps,
  currentStep,
  onStepClick,
}) => {
  return (
    <div className="stepper-container">
      <div className="stepper-wrapper">
        {steps.map((step, index) => {
          const isActive = index === currentStep;
          const isCompleted = step.isCompleted;
          const isPending = !isActive && !isCompleted;
          
          return (
            <React.Fragment key={step.id}>
              <div 
                className={`stepper-item ${isActive ? 'active' : ''} ${isCompleted ? 'completed' : ''} ${isPending ? 'pending' : ''}`}
              >
                {/* Step Circle */}
                <div 
                  className={`stepper-circle ${
                    isActive ? 'active' : ''
                  } ${
                    isCompleted ? 'completed' : ''
                  } ${
                    index <= currentStep ? 'clickable' : ''
                  }`}
                  onClick={() => {
                    // Allow clicking on previous steps or current step
                    if (index <= currentStep) {
                      onStepClick(index);
                    }
                  }}
                >
                  {isCompleted ? (
                    <i className="ph-check" style={{ fontSize: '12px' }}></i>
                  ) : (
                    <span className="stepper-number">{index + 1}</span>
                  )}
                </div>
                
                {/* Step Label */}
                <div className="stepper-label">
                  <span className={`stepper-title ${
                    isActive ? 'active' : ''
                  } ${
                    isCompleted ? 'completed' : ''
                  }`}>
                    {step.title}
                    {step.isOptional && (
                      <span className="optional-text" style={{ marginLeft: '4px' }}>
                        (Optional)
                      </span>
                    )}
                  </span>
                </div>
              </div>
              
              {/* Progress Line */}
              {index < steps.length - 1 && (
                <div 
                  className={`stepper-line ${
                    isCompleted ? 'completed' : ''
                  }`}
                ></div>
              )}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};

export default CampaignStepper;